import { DO_LOGOUT } from '../Login/actions'
import {
    PUT_OBJECTS_GROUP,
    PUT_GROUPS_LIST,
    LOADING,
    TOGGLE_SELECTED_GROUP,
    REMOVE_OBJECTS_GROUP,
    UPDATE_INCLUDES
} from './actions'

const initialState = {
    loading: true,
    groups: [],
    groupsAssoc: {},
    groupsList: [],
    selected: [],
}

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {

        case LOADING:
            return {
                ...state,
                loading: payload.mode
            }

        case UPDATE_INCLUDES:
           
            return {
                ...state,
                groups: state.groups.map(group => {
                    if (payload.add?.msgroup_id && payload.add?.msgroup_id === group.id) {
                        group.objects.push(payload.add.object)
                        group.objectsIds.push(payload.add.object.id)
                    }
                    if (payload.delete?.msgroup_id && payload.delete?.msgroup_id === group.id) {
                        group.objects = group.objects.filter(object => object.id !== payload.delete.id)
                        group.objectsIds = group.objectsIds.filter(id => id !== payload.delete.id)
                    }

                    return group;
                })

            }

        case PUT_OBJECTS_GROUP:
            return {
                ...state,
                groups: payload.groups,
                groupsAssoc: payload.groupsAssoc,
            }

        case PUT_GROUPS_LIST:
            return {
                ...state,
                groupsList: payload.groupsList

            }
        case REMOVE_OBJECTS_GROUP:

            let newObjectAssoc = { ...state.groupsAssoc }
            payload.id.forEach(element => {
                delete newObjectAssoc[String(element)]
            });
            return {
                ...state,
                groupsAssoc: newObjectAssoc,
                groups: state.groups.filter(el => !payload.id.some(id => id === Number(el.id))),
                groupsList: state.groupsList.filter(el => !payload.id.some(id => id === Number(el.id)))
            };

        case TOGGLE_SELECTED_GROUP:
            return {
                ...state,
                selected: payload.selected,
            }

        case DO_LOGOUT:
            return initialState;
    }
    return state
}

export default reducer